import EventsSerializer from './base';

export default class CostMappingOption extends EventsSerializer {
  normalize(modelClass, payload) {
    payload.amount = ((payload.amount ?? 0) / 100).toFixed(2);
    return super.normalize(...arguments);
  }

  serialize() {
    let hash = super.serialize(...arguments);
    hash.amount = Math.round(hash.amount * 100);
    return hash;
  }
}
